/**
 * Application configuration settings
 */
export const appConfig = {
  /**
   * Chat configuration
   */
  chat: {
    /**
     * Whether to show the conversation history sidebar
     * Can be disabled via VITE_ENABLE_CONVERSATION_HISTORY=false
     */
    enableConversationHistory: import.meta.env.VITE_ENABLE_CONVERSATION_HISTORY !== 'false',
  },

  /**
   * Second chat surface: the tool-using agent with first-class citations.
   *
   * Off unless VITE_ENABLE_AGENT_CHAT is exactly 'true', so a deployment that
   * does not set it keeps the existing /chat page as the only chat surface.
   * The backend is gated independently by AGENT_CHAT_ENABLED.
   */
  agentChat: {
    enabled: import.meta.env.VITE_ENABLE_AGENT_CHAT === 'true',
  },

  /**
   * RAG Search configuration
   */
  rag: {
    /**
     * Whether to use streaming for RAG responses
     * When enabled, responses are returned in chunks as they are generated
     * When disabled, responses are returned all at once after completion
     *
     * NOTE: Streaming mode is now enabled for conversational responses
     */
    // useStreaming: true,
    useStreaming: true,

    /**
     * Default context limit for RAG
     * Number of documents to include in the context
     */
    defaultContextLimit: 5,

    /**
     * Maximum number of retries for failed RAG requests
     */
    maxRetries: 3,

    /**
     * Delay between retries in milliseconds
     */
    retryDelay: 1000,
  },

  /**
   * Search configuration
   */
  search: {
    /**
     * Default page size for search results
     */
    defaultPageSize: 5,

    /**
     * Whether to use semantic search by default
     */
    useSemanticSearch: true,
  },
};
